<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="shopitembox">
      <div class="topbox">
        <div class="leftbox">
          <img :src="showsku.skuImage" alt="" />
          <p>{{ shopitem.prodName }}</p>
          <p class="itemtype">{{ shopitem.typeCode }}</p>
          <p class="itemprice">￥{{ price2 }}</p>
          <p class="itemprice">{{ typename }}</p>
        </div>
        <div class="rightbox">
          <p>收货地址</p>
          <div class="reginputboxyear">
            <!-- <p style="width: 4vw">国家</p>
                    <select
                    id="year"
                    v-model="formData.countryName"
                    @change="updataCountry"
                    >
                    <option
                        v-for="country in CountryList"
                        :key="country.abbr"
                        :value="country.chinese"
                    >
                        {{ country.chinese }} ({{ country.english }})
                    </option></select
                    >　 -->
            <p v-if="isChinaSelected">省</p>
            <select
              v-if="isChinaSelected"
              id="Province"
              v-model="formData.stationName"
              @change="updateProvince"
            >
              <option
                v-for="province in ProvinceList"
                :key="province.name"
                :value="province.name"
              >
                {{ province.name }}
              </option>
            </select>
            <p v-if="isChinaSelected">市</p>
            <select
              v-if="isChinaSelected"
              id="City"
              v-model="formData.cityName"
              @change="updateCity"
            >
              <option
                v-for="city in CityList"
                :key="city.name"
                :value="city.name"
              >
                {{ city.name }}
              </option>
            </select>
            <div class="reginputbox">
              <input
                type="text"
                placeholder="地址"
                v-model="formData.address"
              />
            </div>
          </div>
          <p class="righttitle">手机号</p>
          <div class="reginput">
            <div class="reginputbox">
              <input
                type="text"
                placeholder="请输入手机号"
                v-model="formData.phone"
              />
            </div>
          </div>
          <p class="righttitle">收货人</p>
          <div class="reginput">
            <div class="reginputbox">
              <input
                type="text"
                placeholder="请输入收货人"
                v-model="formData.name"
              />
            </div>
          </div>
          <p class="righttitle">数量</p>
          <div class="reginput">
            <div class="reginputbox">
              <input
                type="text"
                placeholder="请输入数量"
                v-model="formData.buynum"
              />
            </div>
          </div>
          <p class="righttitle">
            总价：<span>￥{{ price2 * formData.buynum }}</span>
          </p>

          <div class="buyitem" ><a href="javascript:void(0)" @click="handlebuybtn">购买</a></div>
        </div>
      </div>

      <!-- <div class="midbox">
        <div class="midboxtitle">
          <p>商品详情</p>
        </div>
        <div class="skudes" v-html="shopitem.prodContent"></div>
      </div> -->
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "./../assets/less/global.css";
import countriesData from "@/assets/json/countries.json";
import ProvinceData from "@/assets/json/Province.json";
export default {
  name: "shopbuy",
  data() {
    return {
      shopitem: {},
      chooseskuid: null,
      shopid: null,
      showsku: {},
      price2: 0,
      token: "",
      typename:"m",
      formData: {
        countryName: "中国", // 选中的国家
        countryId: "86",
        stationName: "北京", // 选中的省份
        stationId: "1",
        cityName: "北京", // 选中的城市
        cityId: "1",
        address: "",
        phone: "",
        name: "",
        buynum: 1,
      },
      CountryList: countriesData, // 国家列表
      ProvinceList: ProvinceData, // 省份列表
      CityList: [], // 城市列表
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    isChinaSelected() {
      // 判断是否选择了中国
      return this.formData.countryName === "中国";
    },
  },
  methods: {
    gotoShoplist: function () {
      this.$router.push({
        name: "shop",
      });
    },
    handlebuybtn: function () {
      console.log("handlebuybtn");
      this.sendbuyPostRequest();
    },
    async sendbuyPostRequest() {
      try {
        if (this.isButton1Disabled) return;
        // 禁用按钮
        this.isButton1Disabled = true;
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (
          !this.formData.name ||
          !this.formData.countryName ||
          !this.formData.stationName ||
          !this.formData.cityName ||
          !this.formData.phone ||
          !this.formData.buynum ||
          !this.formData.address
        ) {
          this.error = "";
          return;
        }
        const updata={
            "address": "地址:"+this.formData.stationName+this.formData.cityName+this.formData.address+",收货人:"+this.formData.name+",手机:"+this.formData.phone,
                "skuList": [
                    {
                        "skuId": this.chooseskuid,
                        "count": this.formData.buynum
                    }
                ]
        };

        // 配置 POST 请求的 URL 和数据
        const url = "https://ttserver.aizhuotice.online/api/v1/goods/order";
        console.log(this.formData);
        // 发起 POST 请求
        const response = await axios.post(url, updata, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          alert("提交成功");
          // localStorage.setItem('token', this.response.data.token);
          this.gotoShoplist();
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
        this.isButton1Disabled = false;
      }
    },
    async CheckShopitemList() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          id: this.shopid,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/ttProd/SKU";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response.code);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.shopitem = this.response.data;
        //   console.log(this.shopitem);

          this.shopitem.skuList.forEach((element) => {
            if (this.chooseskuid == element.id) {
              this.showsku = element;
              this.price2 = element.price;
              if (element.skuValue1.length > 0) {
                this.typename = element.skuValue1;
              }
              if (element.skuValue2.length > 0) {
                this.typename = element.skuValue1+" "+element.skuValue2;
              }
            }
          });
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },

    updataCountry() {
      const selectedCountry = this.CountryList.find(
        (country) => country.chinese === this.formData.countryName
      );
      if (selectedCountry) {
        const chinese = selectedCountry.chinese; // 获取中文名
        const code = selectedCountry.code; // 获取国家代码
        console.log("选中的国家:", chinese);
        console.log("国家代码:", code);
        this.formData.countryId = code;
      }
    },
    showProvince() {
      console.log(this.formData.countryName);
      return this.formData.countryName === "中国";
    },
    showCity() {
      return this.showProvince && this.formData.stationName;
    },
    updateProvince() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.stationName);
      // console.log(this.ProvinceList[0].name);
      // console.log(this.ProvinceList[1].name);
      const code = this.findstationCodeByName(this.formData.stationName);
      console.log(code);
      this.formData.stationId = code;
      if (this.formData.stationName) {
        const stationName = this.ProvinceList.find(
          (province) => province.name === this.formData.stationName
        );
        console.log(stationName);
        this.CityList = stationName ? stationName.children : [];
        this.formData.cityName = ""; // 清空城市选择
      } else {
        this.CityList = []; // 清空城市列表
        this.formData.cityName = ""; // 清空城市选择
      }
    },
    getProvinceName(code) {
      // 根据省份代码获取省份名称
      const province = this.ProvinceList.find(
        (province) => province.code === code
      );
      return province ? province.name : "";
    },
    getCityName(code) {
      // 根据城市代码获取城市名称
      const city = this.CityList.find((city) => city.code === code);
      return city ? city.name : "";
    },
    findstationCodeByName(targetName) {
      // console.log(targetName);
      for (const item of this.ProvinceList) {
        if (item.name === targetName) {
          return item.code; // 找到匹配项，直接返回 code
        }
      }
      return null; // 如果找不到，返回 null
    },
    findCityCodeByName(data, targetName) {
      for (const item of data) {
        if (item.name === targetName) {
          return item.code; // 找到匹配项，直接返回 code
        }
      }
      return null; // 如果找不到，返回 null
    },
    updateCity() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.cityName);
      const code = this.findCityCodeByName(
        this.CityList,
        this.formData.cityName
      );
      console.log(code);
      this.formData.cityId = code;
    },
  },
  watch: {
    countryName(newVal) {
      // 当用户切换国家时，如果不是中国，清空省份和城市选择
      if (!this.isChinaSelected) {
        this.formData.stationName = "";
        this.formData.cityName = "";
        this.CityList = [];
      }
    },
  },
  mounted() {
     this.token = localStorage.getItem("token");
    this.shopid = this.$route.params.id;
    this.chooseskuid = this.$route.params.sku;
    // console.log(this.shopid);
    // console.log(this.chooseskuid);
    this.CheckShopitemList();
  },
  created() {
    //  console.log(this.$route.params);
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.shopitembox {
  width: 100vw;
  left: 0vw;
  height: auto;
  position: relative;
  background-color: #181818;
  padding-top: 3vw;
}

.topbox {
  width: 90vw;
  left: 5vw;
  height: 40vw;
  position: relative;
  display: flex;
}
.leftbox {
  width: 30vw;
  height: 20vw;
  position: relative;
}
.leftbox img {
  width: 20vw;
  height: 20vw;
  object-fit: contain; /* 按比例缩放并裁剪 */
}
.leftbox p {
  color: #fff;
  font-size: 1.5vw;
  text-align: left;
  line-height: 2vw;
  width: 90%;
}
.rightbox {
  width: 60vw;
  height: 100%;
  position: relative;
}
.itemtitle {
  width: 100%;
  height: auto;
  position: relative;
  font-size: 1.8vw;
  color: #fff;
  text-align: left;
  /* line-height: 4vw; */
}
.itemtitle p {
  line-height: 2vw;
}
.itemtitle .itemtype {
  font-size: 1.2vw;
  color: #fff;
  text-align: left;
  line-height: 4vw;
  color: #8f8f8f;
}

.buyitem {
  margin-top: 3vw;
  width: 100%;
  height: 3vw;
  position: relative;
  background-color: #a82024;
  color: #fff;
  font-size: 1.5vw;
  text-align: center;
  line-height: 3vw;
}
.midbox {
  margin-top: 3vw;
  border-top: 6px solid #a82024;
  width: 90vw;
  left: 5vw;
  height: auto;
  position: relative;
  background-color: #181818;
  padding-top: 1vw;
  color: #fff;
}
.midboxtitle {
  width: 100%;
  height: 3vw;
  position: relative;
  /* background-color: #a82024; */
  font-size: 1.8vw;
  text-align: center;
  line-height: 3vw;
}

.rightbox p {
  color: #fff;
  font-size: 1.5vw;
  text-align: left;
  line-height: 2vw;
  /* width: 90%; */
  margin-bottom: 1vw;
}
.reginputboxyear,
.reginputbox {
  width: 100%;
  height: 2vw;
  position: relative;
  display: flex;
}

.reginputboxyear p,
.reginput p {
  color: #fff;
  font-size: 1.5vw;
  text-align: left;
  line-height: 2vw;
  display: flex;
  /* width: 90%; */
}

.reginputboxyear select {
  width: 7vw;
  height: 2vw;
  position: relative;
  background-color: #fff;
  color: #000;
}

.reginputboxyear .reginputbox {
  width: 20vw;
  height: 2vw;
  position: relative;
  display: flex;
  margin-left: 1vw;
}
.reginputboxyear .reginputbox input {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  top: 0vw;
  left: 0;
  border: 0px;
}
.reginputbox {
  width: 25vw;
  height: 2vw;
  position: relative;
  display: flex;
  margin-left: 0vw;
}
.rightbox .righttitle {
  width: 100%;
  margin-bottom: 0px;
  margin-top: 1vw;
}

.buyitem a{
    color: #fff;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shopbuy.vue